import * as React from "react";
import { CandyTooltip as BaseTooltip } from "react-ui";

interface Props {
    anchorElement: HTMLElement;
    render: () => React.ReactNode;
    onCloseTooltip: () => void;
}

export const ErrorLogTooltip = ({ onCloseTooltip, render, anchorElement }: Props): JSX.Element => (
    <BaseTooltip
        anchorElement={anchorElement}
        pos={"top left"}
        render={render}
        trigger={"opened"}
        onCloseClick={onCloseTooltip}
        onCloseRequest={onCloseTooltip}
    />
);
